// SuggestedNextList.js
// "Suggested next" card: recommendation rows with a tag and a chevron.
// Items come from useStudentHomeData's mapSuggestions (WP2).
// See docs/superpowers/specs/2026-09-16-home-redesign.md §5 (Student > SuggestedNextList).
import React from "react";
import { MaterialCommunityIcons } from "@expo/vector-icons";

import { homeColors } from "../homeTheme";
import HomeCard from "../primitives/HomeCard";
import HomeRow from "../primitives/HomeRow";

const SuggestedNextList = ({ items = [], onRecommendationPress, isDarkMode = false, t = (s) => s }) => {
  if (!Array.isArray(items) || items.length === 0) return null;

  const colors = homeColors(isDarkMode);

  return (
    <HomeCard title={t("Suggested next")} isDarkMode={isDarkMode} testID="suggested-next-list">
      {items.map((item, index) => (
        <HomeRow
          key={`${item.action || "item"}-${index}`}
          first={index === 0}
          tag={item.tag ? { ...item.tag, label: t(item.tag.label) } : item.tag}
          title={item.title}
          subtitle={item.subtitle}
          action={{
            node: <MaterialCommunityIcons name="chevron-right" size={20} color={colors.ink3} />,
          }}
          onPress={() => onRecommendationPress?.(item)}
          isDarkMode={isDarkMode}
          testID={`suggested-next-row-${index}`}
        />
      ))}
    </HomeCard>
  );
};

export default SuggestedNextList;
